import React from 'react'

interface IListItem {
  key: string | number
  title: string
}

interface IListProps
  extends React.HTMLAttributes<HTMLUListElement | HTMLOListElement> {
  items: IListItem[]
  ordered?: boolean
}

const List: React.FC<IListProps> = ({ items, ordered, ...rest }) => {
  const ListWrapper = ordered ? 'ol' : 'ul'

  return (
    <ListWrapper className='list' {...rest}>
      {items.map((item) => (
        <li key={item.key}>{item.title}</li>
      ))}
    </ListWrapper>
  )
}

export default List
